import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { NavbarComponent } from '../organisms/navbar/navbar.component';
import { SettingsService } from '@services/settings.service';
import { TaskDrawerComponent } from '@features/dashboard/components/off-canvas/task-drawer.component';

@Component({
  selector: 'app-base-page',
  templateUrl: './base-page.component.html',
  styleUrls: ['./base-page.component.scss'],
  imports: [NavbarComponent, TaskDrawerComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasePageComponent {
  @Input() displayNavBar = true;
  private settings = inject(SettingsService);

  isDrawerActive(): boolean {
    return (
      this.settings.isTaskDrawerOpen() || this.settings.isTaskDrawerPinned()
    );
  }

  isPinned() {
    return this.settings.isTaskDrawerPinned();
  }
}
